import { SalesforceAppRow } from '../components/SalesforceAppRow';
import type { AppRow } from '../type/AppRow';

export const salesforceAppRow: AppRow = {
  key: 'salesforce',
  name: 'Salesforce',
  AppComponent: SalesforceAppRow,
};
